import NAME from "./constants";

export const getAssistanceRows = store => store[NAME].assistanceRows || {};
export const getHelp = store => store[NAME].helpDocumentation;
export const gettingAssistanceRows = store => store[NAME].gettingAssistanceRows;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;

export const loading = store => store[NAME].gettingAssistanceRows;
